import { InfiniteData } from '@tanstack/react-query';
import { useBridgeContext } from '@sendible/shared-state-bridge';
import { useInfiniteQueryWithAccessToken } from '../../data-layer/useReactQueryWithAccessToken';
import endpoints from '../../data-layer/endpoints';

export const useGetRecentMedia = ({ userIds, filter }: { userIds?: Array<string>; filter: string }) => {
  const [
    {
      user: { userId },
    },
  ] = useBridgeContext();

  return useInfiniteQueryWithAccessToken<RecentMediaData>(
    [endpoints.GetRecentMedias.endpoint, { per_page: 30, user_id: userIds ? userIds.join(',') : undefined, filter, dashboardId: userId }],
    {
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage?.pageCount) {
          return undefined;
        }

        if (allPages.length < lastPage.pageCount) {
          return allPages.length + 1;
        }

        return undefined;
      },
      retry: false,
      staleTime: Infinity,
      cacheTime: 0,
      select: (data: InfiniteData<RecentMediaData>) => ({
        ...data,
        pages: data.pages.map((page) => ({
          ...page,
          files: page.files.filter((mediaItem) => !mediaItem.url_original.toLowerCase().endsWith('.svg')),
        })),
      }),
    }
  );
};
